"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const GraphandModelPromise_1 = __importDefault(require("./GraphandModelPromise"));
class GraphandModelListPromise extends GraphandModelPromise_1.default {
    constructor(executor, model, query) {
        super(executor, model, query);
        if (this.ids) {
            Object.defineProperty(this, "ids", { enumerable: true, get: () => this._ids });
        }
    }
    /**
     * @readonly
     * @type {string[]}
     * @public
     */
    get _ids() {
        var _a;
        if ((_a = this.query) === null || _a === void 0 ? void 0 : _a.ids) {
            return Array.isArray(this.query.ids) ? this.query.ids : [this.query.ids];
        }
        return [];
    }
    /**
     * @readonly
     * @type {string[]}
     * @public
     */
    get ids() {
        var _a;
        if ((_a = this.query) === null || _a === void 0 ? void 0 : _a.ids) {
            return Array.isArray(this.query.ids) ? this.query.ids : [this.query.ids];
        }
        return [];
    }
    get length() {
        var _a;
        return ((_a = this.ids) === null || _a === void 0 ? void 0 : _a.length) || null;
    }
    clone() {
        return new GraphandModelListPromise(this.executor, this.model, this.query);
    }
    concat(concatWith) {
        const clone = this.clone();
        if (!concatWith) {
            return clone;
        }
        else if (typeof concatWith !== "object") {
            concatWith = new this.model({ _id: concatWith });
        }
        const concatIds = "ids" in concatWith ? concatWith.ids : [concatWith._id];
        clone.query.ids = clone.query.ids || [];
        clone.query.ids = clone.query.ids.concat(concatIds);
        if ("query" in concatWith && concatWith.query.query) {
            clone.query.query = clone.query.query ? { $or: [clone.query.query, concatWith.query.query] } : concatWith.query.query;
        }
        return clone;
    }
    toJSON() {
        return this.ids;
    }
    encodeQuery() {
        return this.ids;
    }
    toString() {
        return JSON.stringify(this.toJSON());
    }
    createObservable() {
        this._observable = new rxjs_1.Observable((subscriber) => {
            this.then((res) => { var _a; return (this._resSub = (_a = res === null || res === void 0 ? void 0 : res.subscribe) === null || _a === void 0 ? void 0 : _a.apply(res, [(r) => subscriber.next(r)])); });
        });
    }
    /**
     * Subscribe to the list. The callback will be called each time (an instance inside) the list is updated in store.
     * If the model is synced (realtime), the callback will be called when the list is updated via socket
     * @param callback - The function to call when the list is updated
     */
    subscribe(callback) {
        if (!this._observable) {
            this.createObservable();
        }
        const sub = this._observable.subscribe(callback);
        const unsubscribe = sub.unsubscribe;
        sub.unsubscribe = () => {
            var _a;
            unsubscribe.apply(sub);
            (_a = this._resSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            delete this._observable;
        };
        return sub;
    }
}
exports.default = GraphandModelListPromise;
